import { graphql } from "gql.tada";
import { RichEntryFragment } from "@queries/fragments/RichEntryFragment";
import { ListItemFragment } from "@queries/fragments/ListItemFragment";
import { ThemeFragment } from "@queries/fragments/ThemeFragment";
import { MetadataFragment } from "@queries/fragments/MetadataFragment";

export const GetConversionPageById = graphql(
  `
    query GetConversionPageById(
      $id: String!
      $locale: String
      $preview: Boolean
    ) {
      conversionPage(id: $id, preview: $preview, locale: $locale) {
        __typename
        slug
        title
        theme { ...ThemeFragment }
        metadata { ...MetadataFragment }
        markets
        navigationAccessibilityLabel
        getStarted {
          title
          description
          firstNameFieldLabel
          lastNameFieldLabel
          emailFieldLabel
          emailFieldInvalid
          titleFieldLabel
          businessPhoneNumberFieldLabel
          advertiserAgencyNameFieldLabel
          additionalAdvertiserFieldLabel
          websiteFieldLabel
          industryVerticalFieldLabel
          industryVerticalOptionsListCollection {
            items {
              label
              value
            }
          }
          advertisingMarketCountryLabel
          advertisingMarketCountryOptionsListCollection {
            items {
              label
              value
            }
          }
          usRegionLabel
          usRegionOptionsListCollection {
            items {
              label
              value
            }
          }
          estimatedCampaignBudgetLabel
          estimatedCampaignBudgetOptionsListCollection {
            items {
              label
              value
            }
          }
          estimatedAnnualSpendOnNetflixLabel
          estimatedAnnualSpendOnNetflixOptionsListCollection {
            items {
              label
              value
            }
          }
          preferredProgrammaticDspUsedLabel
          preferredProgrammaticDspUsedOptionsListCollection {
            items {
              label
              value
            }
          }
          additionalNotesLabel
          inquiryTypeLabel
          inquiryTypeOptionsListCollection {
            items {
              label
              value
            }
          }
          requiredFieldText
          submittedTitle
          submittedNote
          newsletterSignUpLabel
          termsConditionsCheckboxLabel {
            ...RichEntryFragment
          }
          selectOption
          submitButtonLabel
          submittedLabel
          agencyLabel
          pleaseInputNa
        }
        list {
          _id
          viewMoreText
          itemsCollection(limit: 30) {
            total
            items {
              ...ListItemFragment
            }
          }
        }
      }
    }
  `,
  [RichEntryFragment, ListItemFragment, ThemeFragment, MetadataFragment]
);
